import { Icon } from '@ascend/shared/components';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@openzeppelin/ui-components';
import { INITIAL_CLAIM_CASES } from '../data/claims';
import { ClaimsTable } from '../components/ClaimsTable';

export function ClaimsPage() {
  const pendingCount = INITIAL_CLAIM_CASES.filter((item) => item.reviewStatus === 'under_review').length;
  const approvedCount = INITIAL_CLAIM_CASES.filter((item) => item.reviewStatus === 'approved').length;
  const rejectedCount = INITIAL_CLAIM_CASES.filter((item) => item.reviewStatus === 'rejected').length;
  const revokedCount = INITIAL_CLAIM_CASES.filter((item) => item.reviewStatus === 'revoked').length;

  return (
    <div className="space-y-6 sm:space-y-8">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div className="flex items-start gap-3">
          <Icon name="streamline:clipboard-check" className="mt-1 h-6 w-6 sm:h-7 sm:w-7 text-foreground flex-shrink-0" />
          <div>
            <h1 className="text-xl sm:text-2xl font-bold">Claims</h1>
            <p className="text-sm text-muted-foreground">
              Operator view of every claim attached to an Ascend OnchainID. Each row shows
              the wallet, OnchainID, and claim type. Ascend is the issuer; providers
              (Sumsub, Onfido) supply attestation data. Use the row actions to approve,
              reject, or revoke individual claims.
            </p>
          </div>
        </div>
        <div className="flex flex-wrap gap-2">
          <span className="rounded-full bg-yellow-100 px-3 py-1 text-xs font-medium text-yellow-700">
            Pending: {pendingCount}
          </span>
          <span className="rounded-full bg-green-100 px-3 py-1 text-xs font-medium text-green-700">
            Approved: {approvedCount}
          </span>
          <span className="rounded-full bg-orange-100 px-3 py-1 text-xs font-medium text-orange-700">
            Revoked: {revokedCount}
          </span>
          <span className="rounded-full bg-red-100 px-3 py-1 text-xs font-medium text-red-700">
            Rejected: {rejectedCount}
          </span>
        </div>
      </div>

      <Card>
        <CardHeader className="p-6">
          <CardTitle>Credit Facility Claims</CardTitle>
          <CardDescription>
            Global claim queue across all credit facilities. Use the per-facility Claims
            tab on each credit-facility detail page for a scoped view.
          </CardDescription>
        </CardHeader>
        <CardContent className="p-6">
          <ClaimsTable />
        </CardContent>
      </Card>
    </div>
  );
}
